import { render } from "./LearningPlanLesson.vue?vue&type=template&id=68515889&scoped=true"
import script from "./LearningPlanLesson.vue?vue&type=script&lang=js"
export * from "./LearningPlanLesson.vue?vue&type=script&lang=js"

import "./LearningPlanLesson.vue?vue&type=style&index=0&id=68515889&lang=sass&scoped=true"

import exportComponent from "../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68515889"]])

export default __exports__